import React from 'react'

export const Backdrop = (props)=>(
    <div className="back-drop" onClick={props.click} > 
    </div>
)